interface BuildBadgeProps {
  /** Version sémantique depuis package.json (ex. "0.9.0"). */
  version: string;
  /** Commit SHA court injecté au build (ex. "78aab2d"), "dev" en local. */
  sha: string;
  /** Date ISO du build (ex. "2026-05-23"), "dev" en local. */
  date: string;
}

// Pointe sur le CHANGELOG au commit tagué de cette version : toujours
// valide tant que le tag existe (l'auto-bump les pose à chaque PATCH).
// Les Releases GitHub seraient mieux mais ne sont pas auto-créées,
// et le repo est privé donc une 404 release est invisible aux non-membres.
const CHANGELOG_BASE = "https://github.com/Collectif-Flambeau/capture-besoins/blob";

/**
 * Footer build : `Écoute v0.9.0 · 78aab2d · 2026-05-23`.
 * La version est cliquable et ouvre le CHANGELOG.md du repo au tag
 * de cette version exacte (état figé au build, pas le main courant).
 *
 * Permet d'identifier exactement quel commit tourne sur un appareil donné
 * et de retrouver ce qui a changé, indépendamment des bumps `package.json`.
 */
export function BuildBadge({ version, sha, date }: BuildBadgeProps) {
  const releaseUrl = `${CHANGELOG_BASE}/v${version}/CHANGELOG.md`;
  return (
    <footer className="mt-10 text-center text-label text-muted">
      Écoute{" "}
      <a
        href={releaseUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="underline hover:text-flambeau-700"
      >
        v{version}
      </a>{" "}
      · {sha} · {date}
    </footer>
  );
}
